/**
 * Provides the style constants.
 * @public
 */
export const StyleConstants = {
  /** The default component base zindex. */
  defaultComponentBaseZIndex: 'auto',
  /** The default component drag zindex. */
  defaultComponentDragZIndex: '32',
  /** The default component stack maximised zindex. */
  defaultComponentStackMaximisedZIndex: '41',
} as const;
